
import { useGammaWebServices, useLocation, useOrgSettings } from "@/services";
import { computed, defineComponent, ref } from "vue";
import PageHeader from "./PageHeader.vue";
import RiskEntry from "@/components/shared/RiskEntry.vue";
import { ERiskSummaryType, IDisplayItem } from "@/types";
import PrintMap from "@/components/print/PrintMap.vue";
import PrintAccumulations from "@/components/print/PrintAccumulations.vue";
import PrintFloodDetails from "@/components/print/PrintFloodDetails.vue";

export default defineComponent({
  name: "PdfTemplate",
  components: {
    PrintFloodDetails,
    PageHeader,
    RiskEntry,
    PrintMap,
    PrintAccumulations,
  },
  data: () => ({
    currentHref: window.location.href,
  }),
  watch: {
    $route() {
      this.currentHref = window.location.href;
    },
  },
  setup() {
    //DATA
    const displaySections = computed(() => [
      ...useLocation().displaySections,
      ...useGammaWebServices().addressLinkData,
    ]);
    const showAccumulations = useOrgSettings().showLeftAccumulation;
    const showFloodDetails =
      useOrgSettings().settings?.reportSettings?.showFloodDetails;

    const riskEntries = computed(() => useGammaWebServices().mainRisks || []);
    const otherRiskEntries = computed(
      () => useGammaWebServices().otherRisks || []
    );
    const risks = ref<HTMLElement>();
    const riskOverrideLabel = computed(
      () => useOrgSettings().selectedBusinessLine?.riskLookupOverrides?.name
    );
    const riskOverride = computed(
      () => useOrgSettings().selectedRiskOverride?.riskLookupName
    );

    const clientColor = computed(
      () =>
        useOrgSettings().applicationSettings?.clientStyles?.color || "#17a2b8"
    );

    const getColumnName = (item: IDisplayItem) => {
      return item.name || item._column?.columnName.replaceAll("_", " ");
    };

    function isMatchItem(item: any) {
      return item.name?.trim().startsWith("Match");
    }

    return {
      risks,
      displaySections,
      riskEntries,
      otherRiskEntries,
      riskOverrideLabel,
      riskOverride,
      clientColor,
      ERiskSummaryType,
      getColumnName,
      isMatchItem,
      showAccumulations,
      showFloodDetails,
    };
  },
});
